const environmentList = [
  {
    name: "weixinProd",
    url: "https://ykb-wechat.rcghbfk.cn",
  },
  {
    name: "weixinPre",
    url: "https://ykb-wechattest.rcghbfk.cn",
  },
  {
    name: "AppProd",
    url: "https://ykb-h5.rcghbfk.cn",
  },
  {
    name: "AppPre",
    url: "https://ykb-h5test.rcghbfk.cn",
  },
]

export const getEnvironment = () => {
  console.log(window.location.origin, 'location.origin')
  const result = environmentList.find((item) => item.url.indexOf(window.location.origin) !== -1)
  if (result) {
    return result.name
  }
  return null
}